<template>
	<div class="selectlink">
		<div class="dialog-body">
			<div class="filters-container">
				<div class="input-box">
					<span>商品名称：</span>
					<el-input
						style="width:150px"
						v-model="keyword"
						size="mini"
						placeholder="请输入商品"
						@keyup.enter.native="searchClick">
					</el-input>
				</div>
				<div class="input-box">
					<span>商品大类：</span>
					<el-select v-model="bbcTypeCategory" class="filter-input" size='small' @change="bcChange">
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in bc">
							<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
						</template>
					</el-select>
				</div>
				<div v-if="showSmall"  class="input-box">
					<span>商品小类：</span>
					<el-select v-model="sbcTypeCategory" class="filter-input" size='small'>
						<el-option value="0" label="全部"></el-option>
						<template v-for="(item) in sc">
							<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
						</template>
					</el-select>
				</div>
				<el-button size="small" type="primary" class="btn fx-btn" @click="searchClick">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" @click="clearSearch">清空</el-button>
			</div>
			<el-table
				class="grid-content"
				:data="tableData"
				@select="handleSelectionChange"
				@select-all="handleSelectionChange"
				border
				ref="table"
				size='mini'
				height="300"
			>
				<el-table-column
					key='checkbox'
					type="selection"
					align="center"
					width="40">
				</el-table-column>
				<el-table-column
					key="productname"
					prop="productname"
					label="商品名称"
					align="center">
				</el-table-column>
				<el-table-column
					key="bbcname"
					prop="bbcname"
					label="商品大类"
					align="center">
				</el-table-column>
				<el-table-column
					key="sbcname"
					prop="sbcname"
					label="商品小类"
					align="center">
				</el-table-column>
				<el-table-column
					key="productcode"
					prop="productcode"
					label="SPU编号"
					align="center">
				</el-table-column>
			</el-table>
			<div style="display: flex;align-items: center;justify-content: end;height: 40px;">
				<el-pagination
					style="margin: 10px; text-align: center;"
					@size-change="productSizeChange"
					@current-change="productPageChange"
					:current-page="productPagination.page"
					:page-sizes="[20, 40, 60, 100, 300]"
					:page-size="productPagination.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="totalCount">
				</el-pagination>
			</div>
			<div class="valet-foot">
				<el-button size='small' @click='cancelClick'>取消</el-button>
				<el-button type="primary" size='small' @click='saveClick'>添加</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'selectlink',
	props: {
		showSmall: Boolean,
		selectPro: Array
	},
	data () {
		return {
			tableSelectUtils: this.$fxUtils.tableSelectUtils({
				key: 'productid',
				selectHandler: this.tableSelectUtilsHandler
			}),
			fxDataVerification: this.$fxUtils.fxDataVerification(),
			chooseData: null,
			chooseId: '',
			tableData: [],
			sc: [],
			bc: [],
			sbcTypeCategory: '0',
			keyword: '',
			bbcTypeCategory: '0',
			totalCount: 0,
			productPagination: {
				page: 1,
				size: 20
			}
		}
	},
	created () {
		this.tableSelectUtils.add(this.selectPro)
		this.getBigCategory()
		this.searchClick()
	},
	computed: {
		chooseProduct () {
			return this.tableSelectUtils.getSelectRows()
		}
	},
	methods: {
		tableSelectUtilsHandler (row) {
			return {
				productid: row.productid,
				productname: row.productname,
				imgurl: row.imgUrl
			}
		},
		handleSelectionChange (data) {
			this.tableSelectUtils.selectToggle(this.tableData, data)
			console.log(this.chooseProduct)
		},
		saveClick () {
			if (this.chooseProduct.length > 10) {
				this.$message.error('最多勾选10个商品')
				return false
			}
			this.$emit('reloadData', this.chooseProduct)
		},
		cancelClick () {
			this.$emit('cancelClick')
		},
		bcChange (value) {
			this.sbcTypeCategory = '0'
			this.bbcTypeCategory = '' + value
			this.getSmalCategory()
		},
		getBigCategory () {
			let params = {
				disabledFlag: 0
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		getSmalCategory () {
			let params = {
				disabledFlag: 0,
				pid: this.bbcTypeCategory
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		clearSearch () {
			this.productPagination = {
				page: 1,
				size: 20
			}
			this.keyword = ''
			this.disabledflag = -1
			this.typeCategory = '0'
			this.searchClick()
		},
		searchClick () {
			this.getProData()
		},
		getProData () {
			let params = {
				bbcTypeCategory: this.bbcTypeCategory,
				sbcTypeCategory: this.sbcTypeCategory,
				keyword: this.keyword,
				page: this.productPagination.page,
				size: this.productPagination.size
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/shop/style/productattrplanlist`,
				data: params
			}).then(res => {
				this.tableData = res.recordList
				if (this.tableData !== null) {
					this.$nextTick(() => {
						this.tableSelectUtils.setTableDefaultSelect(this.tableData, this.$refs.table)
					})
				}
				this.totalCount = res.recordCount
			})
		},
		productSizeChange (val) {
			this.productPagination.size = val
			this.searchClick()
		},
		productPageChange (val) {
			this.productPagination.page = val
			this.searchClick()
		}
	}
}
</script>

<style lang="stylus" scoped>
.selectlink{
	display: flex;
	flex-direction: column
	padding: 0 10px;
	.select-box{
		border-top: 1px solid #eee
		width: 100%;
		display: flex;
		flex-direction: row;
		height: 60px;
		align-items: center;
		justify-content: flex-start
	}
}
.filters-container {
	display: flex;
	flex-direction: row;
	height: 50px;
	align-items: center;
	margin-bottom:10px;
	.input-box{
		margin-right:10px
	}
	.filter-input{
		width: 120px
	}
}
.valet-foot{
	height :40px;
	display :flex;
	align-items center;
	justify-content :flex-end
}
</style>
<style lang="stylus">
	.cell{
		padding :0px !important
	}
</style>
